export default __webpack_public_path__ + "static/media/OOPT_Certificate.fb25099a.pdf";